import { useNavigationLoading } from '@/hooks'
import { type ReactNode } from 'react'

interface NavigationWrapperProps {
  children: ReactNode
}

export function NavigationWrapper({ children }: NavigationWrapperProps) {
  useNavigationLoading()
  return <>{children}</>
}

export default NavigationWrapper
